import './set-public-path'
import React from 'react'
import ReactDOM from 'react-dom'
import Root from './root.component'
import singleSpaReact from 'single-spa-react'
import { Logger } from '@Techedge/digitalportal-shared'
import packageJson from '../package.json'

// Logger
Logger._packageInfo(
    packageJson.name,
    packageJson.version,
    process.env.REACT_APP_ENV,
    process.env.NODE_ENV,
    'blueviolet',
    'white'
)

if (packageJson && packageJson.dependencies['@lux/wardrobe-lib']) {
    const v = packageJson.dependencies['@lux/wardrobe-lib']
    Logger._packageInfo(
        '@lux/wardrobe-lib',
        v,
        process.env.NODE_ENV,
        v.includes('-dev') ? 'dev' : 'latest',
        'blueviolet',
        'white'
    )
}

const reactLifecycles = singleSpaReact({
    React,
    ReactDOM,
    rootComponent: Root,
    errorBoundary() {
        // Customize the root error boundary for your microfrontend here.
        return null
    },
})

// Export an array of lifecycles to integrate with a framework's
// single-spa lifecycles. The order matters.
export const bootstrap = [reactLifecycles.bootstrap]

export const mount = [
    // The CSS lifecycles should be before your framework's mount lifecycle,
    // to avoid a Flash of Unstyled Content (FOUC)
    reactLifecycles.mount,
]

export const unmount = [
    // The CSS lifecycles should be after your framework's unmount lifecycle,
    // to avoid a Flash of Unstyled Content (FOUC)
    reactLifecycles.unmount,
]
